/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';

import ProfileService from '../../../apiServices/ProfileService';

export const types = {
  REQUEST_ALL: 'app/integrations/REQUEST_ALL',
  RECEIVE_ALL: 'app/integrations/RECEIVE_ALL',
};

const initialState = {};

export default function reducer(state = initialState, action: { type: string; profileId?: number; payload: object }) {
  switch (action.type) {
    case types.RECEIVE_ALL:
      return  _.assign({}, state, {
        [action.profileId]: action.payload,
      });
    case types.REQUEST_ALL:
    default:
      return state;
  }
}

export const selectors = {
  getAll: (state, profileId) => _.get(state, `integrations[${profileId}]`, []),
  hasIntegrations: (state, profileId) => {
    return _.get(state, `integrations[${profileId}]`, []).length > 0;
  },
};

function receiveIntegrations(profileId, consents) {
  return {
    type: types.RECEIVE_ALL,
    profileId,
    payload: consents,
  };
}

function requestIntegrations(profileId) {
  return (dispatch) => {
    return ProfileService.getExistingIntegrations(profileId)
      .then(integrations => {
        dispatch(receiveIntegrations(profileId, integrations));
        return integrations;
      });
  };
}

export const actions = {
  requestIntegrations,
};
